import { render } from "./shopmaison-banner.vue?vue&type=template&id=4455d32e&scoped=true"
import script from "./shopmaison-banner.vue?vue&type=script&lang=js"
export * from "./shopmaison-banner.vue?vue&type=script&lang=js"

import "./shopmaison-banner.vue?vue&type=style&index=0&id=4455d32e&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4455d32e"]])

export default __exports__